<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subjects Pregnant
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Subjects withdrawn due to pregnancy
      </p>
    </b-container>

    <b-container>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>
    </b-row>
    </b-container>
    
    <br />
     <b-card no-body>
        <b-tabs card fill>
         

          <b-tab active>
            <template v-slot:title>
              PREGNANCIES IN PROGRESS ({{subjects.length}})
              <info-popover style="position: relative; left: 30%;">
                <template v-slot:title>
                  Pregnancies In Progress
                </template>

                <p>
                 Subject has tested POS for pregnancy, and Worker has completed the Subject Withdrawal Form for reason Pregnancy
                </p>
            </info-popover>
            </template>
            <b-card-text >

              <b-table striped hover :fields="fields" :items="subjects" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                <template v-slot:cell(subject_name)="data">
                  {{ data.item.subject_case.subject_name }}
                </template>
              
              </b-table>
            </b-card-text>
          </b-tab>
           <b-tab :title="'PREGNANCIES PAST DUE ('+past_due_subjects.length+')'">
             <template v-slot:title>
              PREGNANCIES PAST DUE ({{past_due_subjects.length}})
              <info-popover style="position: relative; left: 30%;">
                <template v-slot:title>
                  Pregnancies Past Due
                </template>

                <p>
                 Subject is past the Estimated Due Date and requires a call back to ensure a healthy delivery to close with final status form
                </p>
            </info-popover>
            </template>
            <b-card-text >
              <b-table striped hover :fields="past_due_fields" :items="past_due_subjects" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                <template v-slot:cell(subject_name)="data">
                  {{ data.item.subject_case.subject_name }}
                </template>

                <template v-slot:cell(dismiss)="data">
                  <b-button class="btn-success" @click="dismiss_clicked(data.item)"><i class="fa fa-check"></i></b-button>
                </template>
              </b-table>
            </b-card-text>
          </b-tab>
          <b-tab :title="'PAST PREGNANCIES (DISMISSED)'">
            <b-card-text >

              <b-table striped hover :fields="fields" :items="dismissed_subjects" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                <template v-slot:cell(name)="data">
                  <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
                </template>
               
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>
     

    <b-modal :ref="'contact_info_modal'" id="contact_info_modal" size="xl" :title="'Contact Information'" ok-only header-class="border-bottom-0">
      <b-row>
        <b-col class="font-weight-bold col-3">
          <h3>Subject Name:</h3>
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          <h3 class="font-weight-light">{{ selected_subject.subject_case.subject_name }}</h3>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Household:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_household }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Relation to HoH:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.relation_to_head }}
        </b-col>
      </b-row>

      <b-row>
        <b-col class="font-weight-bold col-3">
          Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.telephone_number }}
        </b-col>
      </b-row>

      <b-row v-if="selected_subject != null && selected_subject.subject_case.second_telephone_number != null">
        <b-col class="font-weight-bold col-3">
          Second Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.second_telephone_number }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_person }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_phone }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.structure.head_of_structure }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_structure_phone }}
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
// import SubjectFinalStatusRequestTable from "@/pages/unitaid/subject-final-status/SubjectFinalStatusRequests.vue";

import { mapActions, mapState } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    // SubjectFinalStatusRequestTable
  },
  data: function() {
    return {
      aesae_list_fields: [
        { key: "date", label: "AE/SAE Date" },
        { key: "is_ae_sae", label: "Type" },
        { key: "status" },
        { key: "outcome" },
        { key: "ae_sae_id", label: "AE/SAE ID" },
      ],
      fields: [
        { key: "subject_id" },
        { key: "subject_name" },
        { key: "withdrawal_date", label: "Date of Withdrawal" },
        { key: "pregnancy_expected_due_date", label: 'Estimated Delivery Date'}
      ],
      past_due_fields: [
        { key: "subject_id" },
        { key: "subject_name" },
        { key: "withdrawal_date", label: "Date of Withdrawal" },
        { key: "pregnancy_expected_due_date", label: 'Estimated Delivery Date'},
        { key: "baby_followup_complete", label: "Baby Followup Complete"},
        { key: "dismiss", label: "Dismiss", class: "right-text"}
      ],
      past_due_subjects: [],
      subjects: [],
      dismissed_subjects: [],
      componentKey: 0,
      selected_subject: null,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
    };
  },
  computed: {

    ...mapState("user", ["user", "myGroups"]),
  },
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/subjects_pregnant/get_list").then(response => {
      response.data.forEach(element => {
        if(element.dismissed){
          that.dismissed_subjects.push(element);
        }
        else{
          if(element.past_due){
            that.past_due_subjects.push(element);
          }
          else{
            that.subjects.push(element);
          }
        }
      });
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    ...mapActions("subjects_past_due", [
      "getPregnantPastDueCount",
      "setPregnantPastDueCount"
    ]),
    refreshSideNavCount(){
      this.getPregnantPastDueCount().then((response) => {
                this.setPregnantPastDueCount(response.data);
            });
    },
    showModal() {
        this.$refs[('contact_info_modal')].show();
      },
     view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].unresolved_aesae;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].name;
    },
    final_status_approve: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.subjects[index].id+"/", {
        status: 'rclose'
      }).then(response => {
          that.final_status_subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
     rowClicked(record, index){
      let that = this;
      that.selected_subject = record;
      this.showModal(index);
    },
    dismiss_clicked(record){
      let that = this;
      const fd = new FormData();

      fd.append('table_name', 'subject_withdrawal_pregnant');
      fd.append('row_id', record.id);

      HTTP.post('/kenya/dismiss_row/', fd).then(() => {
          for(var i = 0; i < that.past_due_subjects.length; i++){
            if(that.past_due_subjects[i].id == record.id){
              that.past_due_subjects.splice(i, 1);
              that.dismissed_subjects.push(record);
              break;
            }
          }
          that.refreshSideNavCount();
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
.right-text{
  text-align: right;
}

.clickable {
  cursor: pointer;
}
</style>